import PortraitRankingCell from '@/components/model/cell/PortraitRankingCell.vue'
import CircleCell from '@/components/model/cell/CircleCell.vue'
import LandscapeCell from '@/components/model/cell/LandscapeCell.vue'
import PortraitCell from '@/components/model/cell/PortraitCell.vue'
import PreviewInstantPlayerCell from '@/components/model/cell/PreviewInstantPlayerCell.vue'
import { shallowRef } from 'vue'

export const useComponentLoader = () => {
  const component = shallowRef(null)

  /**
   * script setup 환경에서 정의 되지 않는 컴포넌트를 반환할 때 사용한다.
   * thumbnailInfo.componentName 의 규격을 받아 composable 로 component 를 반환
   * @param componentName
   * @returns {unknown}
   */
  const getComponent = (componentName) => {
    switch (componentName) {
      case 'portrait-cell':
        component.value = PortraitCell
        break
      case 'landscape-cell':
        component.value = LandscapeCell
        break
      case 'circle-cell':
        component.value = CircleCell
        break
      case 'portrait-ranking-cell':
        component.value = PortraitRankingCell
        break
      case 'preview-instant-player-cell':
        component.value = PreviewInstantPlayerCell
        break
    }
    return component.value
  }

  return {
    component,
    getComponent,
  }
}
